module.exports = __webpack_public_path__ + "img/consult_info8.7549b705.png";